/*
  MM: Fargesirkler i den faste kjøpslinjen (kun malen product-test).
  Kopierer fargesirklene fra fargevelgeren på siden. Hver sirkel er en <label for="…"> koblet til
  fargevelgerens eget valg, så et trykk i linjen velger fargen i fargevelgeren (nettleserens egen oppførsel).
  Desktop (>=1000px): alle farger, etter produktnavnet. Mobil (<700px): boks med valgt farge først i linjen;
  trykk åpner et fargeark fra bunnen med alle farger (flere enn 7 = scroll inni arket). Synlighet per skjermstørrelse styres i assets/mm-pdp-sticky-bar.css.
  Scriptet endrer ikke handlekurv, skjema eller knapp. Fjernes ved å ta bort lastelinjen i lasteblokken.
*/
(() => {
  if (window.__mmStickySwatches) return;
  window.__mmStickySwatches = true;

  const section = () => document.querySelector('.shopify-section--main-product');

  const picker = () => {
    const root = section();
    return root ? root.querySelector('.product-info .variant-picker') : null;
  };

  const sourceSwatches = () => {
    const p = picker();
    if (!p) return [];
    const group = Array.from(p.querySelectorAll('.variant-picker__option-values')).find((el) =>
      el.querySelector('.color-swatch')
    );
    return group ? Array.from(group.querySelectorAll('.color-swatch')) : [];
  };

  const isSelected = (sw) => {
    if (sw.tagName === 'A') return sw.classList.contains('is-selected');
    const input = sw.htmlFor ? document.getElementById(sw.htmlFor) : null;
    return !!(input && input.checked);
  };

  const copyOf = (sw) => {
    const copy = sw.cloneNode(true);
    copy.removeAttribute('id');
    copy.setAttribute('tabindex', '-1');
    copy.classList.toggle('is-selected', isSelected(sw));
    return copy;
  };

  const ensureHolder = (parent, cls, place) => {
    let holder = parent.querySelector(':scope > .' + cls + ', :scope .' + cls);
    if (!holder) {
      holder = document.createElement('div');
      holder.className = 'mm-sticky-swatches ' + cls;
      holder.setAttribute('aria-hidden', 'true'); // fargevelgeren på siden er den tilgjengelige kontrollen
      place(holder);
    }
    return holder;
  };


  /* ---- Fargeark (mobil) ---- */
  const lang = (document.documentElement.lang || '').toLowerCase();
  const country = ((window.Shopify && window.Shopify.country) || '').toUpperCase();
  /* Danmark ligger i SE-butikken og kan ha svensk språkkode – landet avgjør da dansk tekst */
  const isDa = lang.startsWith('da') || country === 'DK';
  const TXT = isDa ? { title: 'Farver', close: 'Luk' }
    : lang.startsWith('sv') ? { title: 'Färger', close: 'Stäng' }
    : { title: 'Farger', close: 'Lukk' };
  const MAX_ROWS = 7;

  /* Fargenavnet ligger i den skjulte teksten i sirkelen (samme som skjermlesere leser), ikke i input-verdien (ID). */
  const nameOf = (sw) => {
    const sr = sw.querySelector('.sr-only');
    const t = (sr && sr.textContent) || sw.getAttribute('title') || sw.getAttribute('aria-label') || sw.textContent || '';
    return t.replace(/\s+/g, ' ').trim();
  };

  const caret = () => {
    const s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 12 12');
    s.setAttribute('aria-hidden', 'true');
    s.classList.add('mm-shade-box__caret');
    s.innerHTML = '<path d="M2 4.5 6 8.5l4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>';
    return s;
  };

  let sheet = null, lastFocus = null;
  const getSheet = () => {
    if (sheet) return sheet;
    sheet = document.createElement('div');
    sheet.className = 'mm-shade-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="mm-shade-sheet__backdrop" data-close></div>' +
      '<div class="mm-shade-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="mm-shade-sheet-title">' +
        '<div class="mm-shade-sheet__head"><span class="mm-shade-sheet__title" id="mm-shade-sheet-title"></span>' +
        '<button type="button" class="mm-shade-sheet__close" data-close></button></div>' +
        '<ul class="mm-shade-sheet__list" role="listbox"></ul>' +
      '</div>';
    sheet.querySelector('.mm-shade-sheet__title').textContent = TXT.title;
    const closeBtn = sheet.querySelector('.mm-shade-sheet__close');
    closeBtn.textContent = 'X';
    closeBtn.setAttribute('aria-label', TXT.close);
    sheet.style.setProperty('--mm-shade-max-rows', String(MAX_ROWS));
    sheet.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) closeSheet(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && sheet && !sheet.hidden) closeSheet(); });
    document.body.appendChild(sheet);
    return sheet;
  };

  const fillSheet = (swatches) => {
    const s = getSheet();
    const list = s.querySelector('.mm-shade-sheet__list');
    const rows = swatches.map((sw, i) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mm-shade-row';
      const sel = isSelected(sw);
      btn.classList.toggle('is-selected', sel);
      btn.setAttribute('role', 'option');
      btn.setAttribute('aria-selected', sel ? 'true' : 'false');
      const dot = copyOf(sw);
      dot.setAttribute('aria-hidden', 'true');
      dot.classList.add('mm-shade-dot');
      dot.removeAttribute('for');
      const name = document.createElement('span');
      name.className = 'mm-shade-row__name';
      name.textContent = nameOf(sw);
      btn.append(dot, name);
      btn.addEventListener('click', () => {
        const src = sourceSwatches()[i];
        closeSheet();
        if (src) src.click();
      });
      li.appendChild(btn);
      return li;
    });
    list.replaceChildren(...rows);
  };

  const openSheet = () => {
    const s = getSheet();
    fillSheet(sourceSwatches());
    lastFocus = document.activeElement;
    s.hidden = false;
    document.documentElement.classList.add('mm-shade-sheet-open');
    requestAnimationFrame(() => s.classList.add('is-open'));
    document.querySelectorAll('.mm-shade-box').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const cur = s.querySelector('.mm-shade-row.is-selected') || s.querySelector('.mm-shade-row');
    if (cur) { cur.scrollIntoView({ block: 'nearest' }); cur.focus({ preventScroll: true }); }
  };

  const closeSheet = () => {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('mm-shade-sheet-open');
    document.querySelectorAll('.mm-shade-box').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    setTimeout(() => { if (!sheet.classList.contains('is-open')) sheet.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  };

  const build = () => {
    const root = section();
    if (!root) return;
    const bar = root.querySelector('.product-sticky-bar');
    if (!bar) return;
    const inner = bar.querySelector('.product-sticky-bar__inner');
    const vstack = bar.querySelector('.product-sticky-bar__info .v-stack');
    const swatches = sourceSwatches();

    if (swatches.length < 2) {
      bar.querySelectorAll('.mm-sticky-swatches').forEach((el) => el.remove());
      if (sheet) { closeSheet(); }
      return;
    }

    // Desktop: alle farger etter produktnavnet
    if (vstack) {
      const desk = ensureHolder(vstack, 'mm-sticky-swatches--desktop', (h) => {
        const title = vstack.querySelector('.h6');
        if (title) title.after(h); else vstack.prepend(h);
      });
      desk.replaceChildren(...swatches.map(copyOf));
    }

    // Mobil (<700px): boks med valgt farge – åpner fargeark fra bunnen med alle farger
    if (inner) {
      const mob = ensureHolder(inner, 'mm-sticky-swatches--mobile', (h) => inner.prepend(h));
      mob.removeAttribute('aria-hidden');
      const selected = swatches.find(isSelected) || swatches[0];
      let box = mob.querySelector('.mm-shade-box');
      if (!box) {
        box = document.createElement('button');
        box.type = 'button';
        box.className = 'mm-shade-box';
        box.setAttribute('aria-haspopup', 'dialog');
        box.setAttribute('aria-expanded', 'false');
        box.addEventListener('click', () => openSheet());
        mob.replaceChildren(box);
      }
      const dot = copyOf(selected);
      dot.setAttribute('aria-hidden', 'true');
      dot.classList.add('mm-shade-dot');
      dot.removeAttribute('for');
      const name = document.createElement('span');
      name.className = 'mm-shade-box__name';
      name.textContent = nameOf(selected);
      box.replaceChildren(dot, name, caret());
      box.setAttribute('aria-label', TXT.title + ': ' + nameOf(selected));
      fillSheet(swatches);
    }
  };

  let timer = 0;
  const schedule = () => { clearTimeout(timer); timer = setTimeout(build, 60); };

  const start = () => {
    build();
    const root = section();
    if (!root) return;
    root.addEventListener('change', schedule);
    new MutationObserver((records) => {
      if (records.some((r) => !(r.target.closest && r.target.closest('.mm-sticky-swatches')))) schedule();
    }).observe(root, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
